import { RESOURCE_TYPE } from '../services/model';
import { loadBrandfolderWithGenericFileSections, setSelectedBrandfolderId } from './brandfolder';
import { loadCollectionWithGenericFileSections, setSelectedCollectionId } from './collection';

export const setSelectedContainer = (container) => dispatch => {
  // TODO: maybe create a new slice of state to manage the selected container ~PP
  if(container.type === RESOURCE_TYPE.Brandfolder){
    dispatch(setSelectedCollectionId(null))
    dispatch(setSelectedBrandfolderId(container.id))
  } else {
    dispatch(setSelectedBrandfolderId(null))
    dispatch(setSelectedCollectionId(container.id))
  }
}

export const loadContainerWithGenericFileSections = container => dispatch => {
  container.type === RESOURCE_TYPE.Brandfolder ?
    dispatch(loadBrandfolderWithGenericFileSections(container)) :
    dispatch(loadCollectionWithGenericFileSections(container))
}



// WEBPACK FOOTER //
// ./src/actions/container.js